import React from 'react';

import { Button, Box, Typography, Modal } from '@mui/material';
import './SubscriptionPurchasedModal.scss';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
  maxWidth: 460,
  paddingLeft: 10,
  paddingRight: 10,
};

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  email: string;
};

const SubscriptionConfirmationModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  email,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <div>
          <Typography fontSize={16} sx={{ mt: 1, mb: 1 }}>
            You will be redirected to the checkout page
          </Typography>
          <Typography fontSize={16} sx={{ mt: 2, mb: 2 }}>
            Please make sure to enter the same email address used for your
            account ({email}).
          </Typography>
          <Button
            onClick={onConfirm}
            variant='contained'
            color='primary'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '20px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>OK</Typography>
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default SubscriptionConfirmationModal;
